import Files from '@/generated/classes/Files';
import { ExportType as ExportTypeBase } from '@/generated/classes/Files';
import { DownloadData as DownloadDataBase } from '@/generated/classes/Files';
export default class FilesExtend extends Files {
  constructor() {
    super();
  }
}
export class ExportType extends ExportTypeBase {
  constructor() {
    super();
  }
}
export class DownloadData extends DownloadDataBase {
  constructor() {
    super();
  }
}
